import {
  HttpClient,
  HttpErrorResponse,
  HttpResponse,
} from '@angular/common/http';
import { Component, Inject, Injectable, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialog,
} from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { AppInitService } from '../app-init.service';
import { AuthenticationService } from '../authentication.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MessageDisplayService {
  constructor(
    private toastr: ToastrService,
    public dialog: MatDialog,
    private appInitService: AppInitService,
    private authenticationService: AuthenticationService,
    private http: HttpClient
  ) {}
  toasterClickedHandler(): void {
    //Implementation of  toster event when it is clicked
    console.log('Toaster Clicked');
  }
  openDialog(msg, dataTemp, fromWhereTemp): void {
    //static start
    /*  const dialogDataTemp = [
      {
          "code": "AUP004",
          "message": "Employee Last Name not present",
          "messageType": 4
      },
      {
          "code": "AUP005",
          "message": "Employee User Name not present",
          "messageType": 2
      }
  ] */
    //Static end

    const dialogDataTemp = {
      msgTitle: msg,
      dataForLoop: dataTemp,
    };

    //static start
    /*  const viwDataTemp = {
       fromWhere: 'error',
       dialogData: dialogDataTemp
     } */
    //Static end

    const viwDataTemp = {
      fromWhere: fromWhereTemp,
      dialogData: dialogDataTemp,
    };
    const dialogRef = this.dialog.open(httpInterceptorDialogComponent, {
      disableClose: true,
      data: viwDataTemp,
      width: '40%',
    });
    dialogRef.afterClosed().subscribe((result) => {
      try {
        if (result) {
          console.log(result);
        }
      } catch (err) {
        console.log('Dialog closed');
      }
    });
  }
  successMsg(event: HttpResponse<any>) {
    const successRes = event.body;
    if (successRes.msgDisplay === 1) {
      this.successToast(successRes);
      // this.toastr.success(successRes.message, '', {
      //   disableTimeOut: true
      // });
    } else if (successRes.msgDisplay === 2) {
      //open Dialog
      this.toastr.error(
        `<ul class="toastList">
      ${String(
        successRes.messages
          .map((successObj) => `<li>${String(successObj)}</li>`)
          .join('')
      )}
      </ul>`,
        'Invalid',
        {
          enableHtml: true,
          positionClass: 'toast-top-center',
          closeButton: true,
        }
      );
    }
  }
  errorMessage(response: HttpErrorResponse) {
    if (response.status === 401 && !this.appInitService?.appConfig?.dev) {
      //this.toastr.error(response.message, '');
      console.log('Authenticatoin Error 401: ', response.message);

      if (
        (this.appInitService?.appConfig?.authType == 'jwt' ||
          this.appInitService?.appConfig?.authType == 'cookie' ||
          this.appInitService?.appConfig?.authType == 'oauth2') &&
        !response.url.includes('login') &&
        !response.url.includes('logout')
      ) {
        this.authenticationService.logout();
      }
    }
    const errorRes: any = response.error;
    if (errorRes.msgDisplay === 1) {
      //   this.toastr.error(errorRes.errors[0].message);
      /*   let msg = '';
        for(var i=0; i < errorRes.errors.length; i++){
          if(msg == ''){
            msg = errorRes.errors[i].message;
          } else {
            msg = msg + ','+ errorRes.errors[i].message;
          }
        }
        this.toastr.error(msg,errorRes.message); */

      this.errorToast(errorRes);
    } else if (errorRes.msgDisplay === 2) {
      //open Dialog
      this.openDialog(errorRes.message, errorRes.errors, 'error');
    } else if (errorRes.msgDisplay === 4) {
      // this.customToast.onCustomToastShowFunction({ errorList: errorRes.errors, errorMsg: errorRes.message });
    }

    const err = response.error.message || response.statusText;
    return err;
  }
  insertAlert(newJson: any): Observable<any> {
    return this.http.post('/admin/insert-alert-messages', newJson);
  }
  updateAlert(newJson: any): Observable<any> {
    return this.http.put('/admin/update-alert-messages', newJson);
  }
  deleteAlert(newJson: any): Observable<any> {
    return this.http.put('/admin/delete-alert-messages', newJson);
  }
  successToast(successBody) {
    this.toastr.success(
      `<ul class="toastList">
    ${String(
      successBody.messages
        .map((successObj) => `<li>${String(successObj)}</li>`)
        .join('')
    )}
    </ul>`,
      'Success',
      {
        enableHtml: true,
        positionClass: 'toast-top-center',
        closeButton: true,
      }
    );
  }
  errorToast(errorRes) {
    this.toastr.error(
      `<ul class="toastList">
      ${String(
        errorRes.errors
          .map((erroObj) => `<li>${String(erroObj.message)}</li>`)
          .join('')
      )}
      </ul>`,
      'Error',
      /* errorRes.message, */
      {
        enableHtml: true,
        positionClass: 'toast-top-center',
        closeButton: true,
        progressBar: true,
      }
    );
  }
}

@Component({
  templateUrl: 'dialog.html',
  styleUrls: ['./dialog.scss'],
})
export class httpInterceptorDialogComponent implements OnInit {
  viewData: any;
  currentView: any;
  viewErrorTitle: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<httpInterceptorDialogComponent>
  ) {}

  ngOnInit(): void {
    console.log('Dialog Initiated for Http Interceptor');
    this.currentView = this.data.fromWhere;
    this.viewData = this.data.dialogData.dataForLoop;
    this.viewErrorTitle = this.data.dialogData.msgTitle;
  }

  onNoClick(): void {
    //  console.log("closeDialog");
    this.dialogRef.close('closeDialog');
  }
}
